import ArFormCombobox from "../form/ComboBoxFormField";
import { FieldValues, Path } from "react-hook-form";
import FindAllTermsAndConditions from "@/v2/api/terms-and-conditions/FindAll";
import { TermsAndCondition } from "@/v2/types";

export function TermsAndConditionsComboBox<T extends FieldValues>({
    name,
    storeFullObject = false,
    setSelected,
    defaultValue,
}: {
    name: Path<T>;
    storeFullObject?: boolean;
    setSelected?: (value: TermsAndCondition | null) => void;
    defaultValue?: TermsAndCondition | null;
}) {
    return (
        <ArFormCombobox<T, TermsAndCondition>
            name={name}
            defaultValue={defaultValue}
            label=""
            queryKey="terms-and-conditions"
            queryFn={async ({ pageParam, search, limit }) =>
                FindAllTermsAndConditions({
                    skip: pageParam,
                    limit,
                    search,
                })
            }
            getDisplayValue={(terms) => terms.template_name}
            renderItem={(terms) => (
                <div className="flex flex-col">
                    <span>{terms.template_name}</span>
                </div>
            )}
            placeholder="Select template..."
            width="w-full"
            storeFullObject={storeFullObject}
            onItemSelect={(role: TermsAndCondition | null) => {
                setSelected && setSelected(role);
            }}
        />
    );
}
